import React, { useRef, useLayoutEffect } from 'react';
// import { useStopGuestimatingController } from './StopGuestimating.controller';
import { SpacingStack } from '@components/SpacingStack';
import { TextPairing } from '@components/TextPairing';
import { Box, BoxProps } from '@components/Box';
import { Columns } from '@components/Columns';
import { guestListData } from '@data-ts/pages/guest-list';
import { useScrollController } from '@context/ScrollControllerProvider/useScrollController';
import { useIsMounted } from '@hooks/useIsMounted';
import ScrollMagic from 'scrollmagic';
import { CTALink } from '@components/CTALink';
import { useThemeMediaQuery } from '@hooks/useThemeMediaQuery';

interface StopGuestimatingProps
  extends Readonly<{
    backgroundColor: BoxProps['backgroundColor'];
  }> {}

export const StopGuestimating: React.FC<StopGuestimatingProps> = ({ backgroundColor }) => {
  const isMobile = useThemeMediaQuery('below_sm');
  // TODO: remove if unused.
  // const [containerPosition, setContainerPosition] = useState(0);
  const stopGuestimatingContainerId = 'Guest_List_RSVP_Cross';
  const stopGuestimatingContainerRef = useRef<HTMLDivElement>(null);
  const scrollController = useScrollController();
  const isMounted = useIsMounted();
  const stopGuestimatingData = guestListData.stopGuestimating;

  useLayoutEffect(() => {
    let scene: InstanceType<typeof ScrollMagic.Scene> | undefined;

    const guestContainerEl = stopGuestimatingContainerRef.current;
    if (scrollController && isMounted && guestContainerEl) {
      const initScene = () => {
        scene = new ScrollMagic.Scene({
          triggerElement: guestContainerEl,
          triggerHook: 0,
          duration: '10%',
          offset: 20,
        }).addTo(scrollController);
        // TODO: Remove since we're not using the containerPosition variable here.
        /*
          .on('progress', (event: ScrollMagic.SceneProgressEvent) => {
            event.progress * 100 > 5 ? setContainerPosition(20) : setContainerPosition(0);
          });
        */
      };
      initScene();
    }
    const clearScene = () => {
      if (scene) {
        scene.destroy(true);
      }
    };
    return () => {
      clearScene();
    };
  }, [scrollController, isMounted]);

  return (
    <Box
      backgroundColor={backgroundColor}
      paddingTop={[10, 10, 10]}
      style={{ overflowX: 'hidden' }}
      ref={stopGuestimatingContainerRef}
      id={stopGuestimatingContainerId}
    >
      <Columns>
        <Columns.Column>
          <SpacingStack spacing={8}>
            <TextPairing
              alignment="center"
              eyebrow={stopGuestimatingData.eyebrow}
              eyebrowColor="humanaDark4"
              eyebrowVariant={isMobile ? 'sectionEyeBrow24' : 'calloutHed32'}
              eyebrowTagName="h2"
              title={stopGuestimatingData.title}
              titleColor="neutra6"
              titleVariant="hed72Hero"
              titleTagName="h2"
              body={stopGuestimatingData.content}
              bodyMaxWidth="660px"
              bodyVariant="dek24"
              bodyColor="neutra5"
            />
            <Box style={{ textAlign: 'center' }} paddingBottom={[10]}>
              <CTALink id="stopGuestimating" href="/online-rsvp" typography={'featureHed17'} hasChevron>
                {stopGuestimatingData.learnMore}
              </CTALink>
            </Box>
          </SpacingStack>
        </Columns.Column>
      </Columns>
    </Box>
  );
};
